module.exports = __webpack_public_path__ + "static/media/4.14e9fa3c.jpeg";